import { useState } from "react";

const faqs = [
  {
    q: "How much does it cost to trim a tree?",
    a: "Tree trimming costs typically range from $150 to $1,800 depending on the tree's size, species, and location. Small trees (under 30 ft) average $150–$400, medium trees (30–60 ft) average $400–$900, and large trees (60+ ft) can cost $900–$1,800. Getting multiple quotes is the best way to find a fair price in your area.",
  },
  {
    q: "How much does it cost to remove a fallen tree?",
    a: "Fallen tree removal typically costs $100–$500 for smaller trees and $500–$1,500+ for large trees. Emergency removal after a storm can run $500–$2,500 depending on urgency, accessibility, and debris volume. Many homeowners insurance policies cover storm-related tree removal — check your policy before paying out of pocket.",
  },
  {
    q: "How much does it cost to remove a shrub?",
    a: "Shrub removal generally costs $25–$75 per shrub for small bushes, and $150–$400 for large, established shrubs with deep root systems. If you have multiple shrubs, most pros offer bulk pricing. Stump grinding for shrubs adds $50–$150 per stump.",
  },
  {
    q: "Do tree service companies need to be insured?",
    a: "Yes — always hire a tree service company that carries both general liability insurance and workers' compensation insurance. Liability insurance protects your property if something goes wrong, while workers' comp covers the crew if anyone is injured on your property. All pros in our network are verified to carry proper coverage.",
  },
  {
    q: "What is the best time of year to trim trees?",
    a: "Late winter to early spring (February–April) is generally the best time to trim most trees, as they're dormant and less susceptible to disease or pest infestation. However, dead or hazardous branches should be removed any time of year. Palm trees are best trimmed in late spring. Avoid heavy pruning in fall, as it can stimulate new growth before frost.",
  },
  {
    q: "How do I find a reputable tree service near me?",
    a: "Look for companies with ISA-certified arborists, valid state licenses, and comprehensive insurance. Check online reviews on Google and Yelp, ask for references, and always get at least 3 written quotes before hiring. Our platform pre-screens all pros for licensing, insurance, and customer ratings so you can compare with confidence.",
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-white py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Left */}
          <div className="lg:col-span-1">
            <span className="inline-block text-[#1B4332] text-xs font-bold uppercase tracking-widest mb-3">
              FAQs
            </span>
            <h2 className="text-2xl md:text-3xl font-extrabold text-[#1B4332] mb-4">
              Tree Service FAQs
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              Common questions homeowners ask before hiring a tree service professional.
            </p>
            <a
              href="/cost-guide"
              className="inline-flex items-center gap-2 text-[#1B4332] font-semibold text-sm hover:underline cursor-pointer"
            >
              View Full Pricing Guide <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          {/* Right - Accordion */}
          <div className="lg:col-span-2 flex flex-col gap-3">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className="border border-gray-100 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => setOpen(open === idx ? null : idx)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-[#F7F9F8] transition-colors"
                >
                  <span className="font-semibold text-[#1B4332] text-sm md:text-base">{faq.q}</span>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className={`text-[#1B4332] text-lg transition-transform duration-200 ${open === idx ? "ri-subtract-line" : "ri-add-line"}`}></i>
                  </div>
                </button>
                {open === idx && (
                  <div className="px-5 pb-5">
                    <p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
